import { Button, Heading, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError, useNavigate } from 'react-router-dom';

export default function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  const navigate = useNavigate();
  useEffect(() =>{
    console.log('########################ErrorPage########################')
    console.log(error)
  }, [error])
  return (
    <div
      id="error-page"
      className="d-flex justify-content-center my-5"
    >
      <div className="my-5">
        <Heading
          as="h1"
          className="my-4"
        >
          {t('OOPS')}
        </Heading>
        <Text
          fontSize="xl"
          my="5"
        >
          {t('ERROR_OCCURRED')}
        </Text>
        <Text
          fontSize="lg"
          color="red.500"
          my="5"
        >
          <i>{error.statusText ? error.statusText :  error.message}</i>
        </Text>
        <Button
          mt="5"
          colorScheme="blue"
          onClick={() => navigate('/')}
        >
          {t('GO_BACK_HOME')}
        </Button>
      </div>
    </div>
  );
}
